import editCustomerForm from './editCustomerFormModel';
const {
  formField: {
    // DATOS CLIENTE 
    e_name,
    e_address,
    e_email,
    e_person_in_charge,
    e_contact,
    e_second_person_in_charge,
    e_second_customer_contact,
    e_phone,
    e_start_date,
    e_status,
    e_country,
    e_departament,
    e_municipaly,
    e_applications,
    e_subscription_ends_at 
  }
} = editCustomerForm;

export default {
  [e_name.name]: '',
  [e_address.name]: '',
  [e_email.name]: '',
  [e_person_in_charge.name]: '',
  [e_contact.name]: '',
  [e_second_person_in_charge.name]: '',
  [e_second_customer_contact.name]: '',
  [e_phone.name]: '',
  [e_start_date.name]: new Date(),
  [e_status.name]: true,
  [e_country.name]: '',
  [e_departament.name]: '',
  [e_municipaly.name]: '',
  [e_applications.name]: null,
  [e_subscription_ends_at.name]: null 
};

